module.exports = __webpack_public_path__ + "static/media/MVNZ_web_1_preview.e4cadc86.jpg";